import React from 'react';
import { motion } from 'framer-motion';
import './Commercial.css';

const Commercial: React.FC = () => {
  return (
    <div className="venture-page">
      <div className="venture-container">
        {/* Main Content */}
        <div className="venture-content">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="venture-main-section"
          >
            <div className="venture-header">
              <div className="venture-header-background"
                style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/mall.jpeg)` }}
              >
                <div className="venture-header-overlay">
                  <h2 className="section-main-title">Commercial</h2>
                </div>
              </div>
            </div>
            <div className="venture-content-container">
              <motion.div
                initial={{ opacity: 0, x: -50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.8 }}
                viewport={{ once: true }}
                className="venture-text-section"
              >
                <div className="venture-text-content">
                  <div className="venture-text">
                    <p>
                      <b>Ansuvara Group</b> holds a powerful and growing presence in Pokhara's commercial real estate sector, with landmark assets that have significantly shaped the city's retail and business environment. The Group maintains a majority stake in Pokhara Trade Mall, proudly recognized as Nepal's largest mall, spanning an impressive 145,000 sq. ft. built-up area and housing 502 retail stores that accommodate a diverse mix of brands, services, and commercial enterprises. This iconic property has become a central urban hub, driving retail activity, supporting hundreds of local businesses, and attracting a high volume of footfall.
                    </p>
                    <p>
                      Alongside this, Ansuvara Group fully owns Ansuvara Square, a fast-emerging commercial complex that offers versatile retail and office spaces designed for modern businesses seeking strategic placement, quality infrastructure, and a dynamic commercial environment.
                    </p>
                    <p>
                      Strengthening its portfolio further, the Group is developing 31 Avenue, a landmark mixed-use project set to redefine Barahi Chowk in Lakeside, one of Pokhara's most vibrant and high-value zones. Envisioned as a next-generation commercial destination, 31 Avenue will integrate premium retail outlets, luxurious hotel accommodations, and exceptional dining experiences into a single well-designed complex, creating a new benchmark for business, lifestyle, and hospitality in the city.
                    </p>
                    <p>
                      Together, these developments reflect Ansuvara Group's long-term commitment to elevating Pokhara's commercial infrastructure, fostering economic growth, and building modern, future-ready spaces that support the region's expanding urban and entrepreneurial landscape.
                    </p>
                  </div>
                </div>
              </motion.div>
            </div>

              {/* Mall Displays Section */}
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            viewport={{ once: true }}
            className="mall-displays-section"
          >
            <div className="mall-displays-container">
              <div className="mall-cards-grid">
                {/* 31 Avenue */}
                <motion.div
                  whileHover={{ scale: 1.05 }}
                  transition={{ duration: 0.3 }}
                  className="mall-card"
                >
                  <a 
                    href="https://31avenuelakeside.com" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="mall-card-link"
                  >
                    <div className="mall-card-image">
                      <div 
                        className="mall-card-bg"
                        style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/mall.jpeg)` }}
                      ></div>
                      <div className="mall-card-overlay">
                        <h4 className="mall-card-name">31 Avenue</h4>
                      </div>
                    </div>
                  </a>
                </motion.div>

                {/* Ansuvara Square */}
                <motion.div
                  whileHover={{ scale: 1.05 }}
                  transition={{ duration: 0.3 }}
                  className="mall-card"
                >
                  <a 
                    href="https://ansuvarasquare.com" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="mall-card-link"
                  >
                    <div className="mall-card-image">
                      <div 
                        className="mall-card-bg"
                        style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/square_silhouette_2.jpeg)` }}
                      ></div>
                      <div className="mall-card-overlay">
                        <h4 className="mall-card-name">Ansuvara Square</h4>
                      </div>
                    </div>
                  </a>
                </motion.div>

                {/* Pokhara Trade Mall */}
                <motion.div
                  whileHover={{ scale: 1.05 }}
                  transition={{ duration: 0.3 }}
                  className="mall-card"
                >
                  <a 
                    href="https://pokharatrademall.com" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="mall-card-link"
                  >
                    <div className="mall-card-image">
                      <div 
                        className="mall-card-bg"
                        style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/mall_face.jpg)` }}
                      ></div>
                      <div className="mall-card-overlay">
                        <h4 className="mall-card-name">Pokhara Trade Mall</h4>
                      </div>
                    </div>
                  </a>
                </motion.div>
              </div>
            </div>
          </motion.div>

          </motion.div>

        
        </div>
      </div>
    </div>
  );
};

export default Commercial;
